import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchDetailed(action) {
  try {
    const { filtersString } = action.payload;
    const response = yield call(API.fetchSamplingTrackingDetailed, {
      filtersString,
    });
    const data = response?.data?.data;
    yield put(actions.fetchDetailedSuccess({ data }));
  } catch (error) {
    console.error("❌ Saga error:", error);
    yield put(actions.fetchDetailedFailure(error.message || "Unknown error"));
  }
}

export function* samplingTrackingDetailedSaga() {
  yield takeLatest(actions.fetchDetailed.type, handleFetchDetailed);
}